
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sites/[siteId]",
      function () {
        return require("private-next-pages/sites/[siteId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sites/[siteId]"])
      });
    }
  